import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { connect } from "react-redux";
import * as actions from "redux/actions/followerListActions";
import { AvatarOrInitials } from 'utils/avatarUtils';

function FollowItem({ item }) {
    return (
        <div className="list-item">
            <RouterLink to={`/profile/${item.id}`} className="list-item-link">
                <AvatarOrInitials
                    avatarUrl={item.avatar}
                    name={item.username}
                    className="list-item-avatar-img"
                    alt={item.username}
                />
                <span className="list-item-text">{item.username}</span>
            </RouterLink>
        </div>
    );
}

const FollowListModal = (props) => {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        if (!props.disabled) {
            return;
        }
        setOpen(true);
        props.loadList({
            id: props.user_id,
            follower_id: props.item.id,
            kind: props.kind,
        }, props.token);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div className="follow-list-modal">
            <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={handleClickOpen}
                disabled={!props.disabled}
            >
                {props.button_label}
            </button>
            {open && (
                <div className="follow-list-overlay" onClick={handleClose} role="presentation">
                    <div
                        className="follow-list-dialog"
                        onClick={(e) => e.stopPropagation()}
                        role="dialog"
                        aria-modal="true"
                    >
                        <div className="follow-list-dialog-title">{props.title}</div>
                        <div className="follow-list-dialog-body">
                            {props.list.length === 0 ? (
                                <p className="follow-list-empty">—</p>
                            ) : (
                                props.list.map((element) => (
                                    <FollowItem key={element.id} item={element} />
                                ))
                            )}
                        </div>
                        <div className="follow-list-dialog-actions">
                            <button type="button" className="btn btn-secondary btn-sm" onClick={handleClose}>
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

function mapStateToProps(reducer) {
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,
        list: reducer.followerList.list,
    };
}

const mapDispatchToProps = dispatch => ({
    loadList: (params, token) =>
        dispatch(actions.loadList({ params, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(FollowListModal);
